<div class="skeleton-card">
  <div class="skeleton-card__column">
    <div class="skeleton skeleton--text short large"></div>
    <div class="row">
      <div class="skeleton skeleton--text"></div>
      <div class="skeleton skeleton--text"></div>
      <div class="skeleton skeleton--text"></div>
    </div>
  </div>
  <div class="skeleton-card__column">
    <div class="skeleton skeleton--text short right large"></div>
    <div class="skeleton skeleton--text"></div>
  </div>
</div>
